var _path, _g, _use, _use2, _use3, _use4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRound55A = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  fill: "none",
  viewBox: "0 0 55 54",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M40 28c0 6.627-5.373 12-12 12s-12-5.373-12-12 5.373-12 12-12 12 5.373 12 12Z"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-figma-trr": "r5u2.5-0f"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M28.001 12c-3.314 0-6-2.239-6-5s2.686-5 6-5 6 2.239 6 5-2.686 5-6 5Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#BABCC0",
  fillRule: "evenodd",
  d: "M33.001 7c0-2.046-2.06-4-5-4s-5 1.954-5 4v1a1 1 0 1 1-2 0V7c0-3.477 3.312-6 7-6s7 2.523 7 6v1a1 1 0 0 1-2 0V7Z",
  clipRule: "evenodd"
}))), _use || (_use = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#Round-5-5-A_svg__Repeat%20group%201_inner",
  transform: "rotate(72 27.517 28.483)"
})), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#Round-5-5-A_svg__Repeat%20group%201_inner",
  transform: "rotate(144 27.517 28.483)"
})), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#Round-5-5-A_svg__Repeat%20group%201_inner",
  transform: "rotate(-144 27.517 28.483)"
})), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#Round-5-5-A_svg__Repeat%20group%201_inner",
  transform: "rotate(-72 27.517 28.483)"
})));
SvgRound55A.viewBox = '0 0 55 54';
const ForwardRef = /*#__PURE__*/forwardRef(SvgRound55A);
export default ForwardRef;